import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { BellRing, X } from "lucide-react";
import { toast } from "sonner";

export default function FollowedDeitiesCard() {
  const [items, setItems] = useState(null);
  const load = () => api.get("/follows/me").then((r) => setItems(r.data.items)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);
  if (!items) return null;
  const unfollow = async (slug) => { await api.delete(`/follows/${slug}`); toast.success("Unfollowed"); load(); };

  return (
    <div data-testid="followed-deities-card" className="bg-[#FFFDF9] sacred-border rounded-2xl p-6">
      <div className="flex items-center gap-2"><BellRing className="w-5 h-5 text-[#E65100]" /><div className="overline">Deities you follow</div></div>
      {items.length === 0 ? (
        <p className="text-sm text-[#63534E] mt-3">Follow a god or goddess to get an email 3 days before their festivals. <Link to="/deities" className="text-[#E65100] font-semibold">Browse deities →</Link></p>
      ) : (
        <div className="mt-4 flex flex-wrap gap-3">
          {items.map((d) => (
            <div key={d.slug} data-testid={`followed-${d.slug}`} className="flex items-center gap-2 bg-white border border-[#D4AF37]/40 rounded-full pl-1 pr-2 py-1">
              <img src={d.image_url} alt="" className="w-8 h-8 rounded-full object-cover" />
              <Link to={`/deities/${d.slug}`} className="text-sm text-[#4A0E17] font-semibold">{d.name}</Link>
              <button data-testid={`unfollow-${d.slug}`} onClick={() => unfollow(d.slug)} aria-label={`Unfollow ${d.name}`} className="text-[#8C6D3B] hover:text-red-700"><X className="w-4 h-4" /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
